<div class="layout-main">
    <mat-toolbar color="primary">
        <mat-toolbar-row>
            <button mat-icon-button (click)="sidenav.toggle()" fxShow="true" fxHide.gt-md [disableRipple]="true">
                <i class="material-symbols-rounded">{{ sidenav.opened ? ZenIconsEnum.CLOSE : 'menu' }}</i>
            </button>
            <span class="ms-4 me-3 me-sm-3 me-md-5">
                <a href="#" target="_blank">
                    <img src="./images/zentility-mp-logo.svg" alt="Zentility"/>
                </a>
            </span>

            <div fxShow="true" fxHide.lt-lg>
                <!-- The following menu items will be hidden on both SM and XS screen sizes -->
                <ng-container *ngFor="let op of menuOptions">
                    <a mat-button class="text-md text-color mx-2" [routerLink]="op.link" routerLinkActive="router-link-active">{{op.label}}</a>
                </ng-container>
            </div>

            <span class="menu-spacer"></span>

            <div fxHide.lt-sm>
                <img *ngIf="supplierLogoPath else supplierNameTpl" class="supplier-logo" [src]="supplierLogoPath">
                <ng-template #supplierNameTpl>
                    <p class="me-4">{{currentUser?.supplierRep?.supplierName}}</p>
                </ng-template>
            </div>

            <!-- Future enhancement -->
            <button mat-mini-fab class="user-menu-btn" [matMenuTriggerFor]="settingsMenu">
                <span>{{currentUser?.supplierRep?.firstName?.charAt(0)}}</span>
            </button>

            <mat-menu #settingsMenu>
                <a mat-menu-item>
                    <span class="font-weight-bold">{{currentUser?.supplierRep?.firstName}} {{currentUser?.supplierRep?.lastName}}</span>
                </a>
                <a mat-menu-item (click)="authSvc.logout()">Logout</a>
            </mat-menu>

        </mat-toolbar-row>
    </mat-toolbar>

    <mat-sidenav-container fxFlexFill>
        <mat-sidenav #sidenav class="mobile-side-nav">
            <mat-nav-list>
                <ng-template [ngTemplateOutlet]="allItems"></ng-template>
            </mat-nav-list>
        </mat-sidenav>
        <mat-sidenav-content fxFlexFill>
            <div class="router-outlet-main">
                <div class="router-outlet-container" [class.bc-exist]="bcSvc.config">
                    <div class="m-3">
                        <div class="mb-5" *ngIf="bcSvc.config">
                            <app-breadcrumb></app-breadcrumb>
                        </div>
                        <router-outlet/>
                    </div>
                </div>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>

<ng-template #allItems>
    <ng-container *ngFor="let op of menuOptions">
        <a mat-list-item [routerLink]="op.link" (click)="sidenav.close()"
           routerLinkActive="router-link-active"><span class="text-md">{{op.label}}</span></a>
    </ng-container>
</ng-template>
